import { useEffect, useRef, useState } from "react";
import { Input, Label } from "reactstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import FormBuilder from "../../formBuilder/formBuilder";
import { createForm, updateForm } from "../../../../store/slices/formBuilder";
import PreviewForm from "../../formBuilder/previewForm";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const CreateFormBuilder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data || {};
  const formBuilderRef = useRef();
  const dispatch = useDispatch();
  const [form, setForm] = useState([]);
  const [json, setJson] = useState([]);
  const [type, setType] = useState("form");
  const [activeTab, setActiveTab] = useState(1);
  const [name,setName] = useState("")

  useEffect(() => {
    if (data?.ID) {
      const formEditData = JSON.parse(data?.formFields || '[]')
      const formJsonData = data?.json ?? JSON.parse(data?.json)
      setForm(formEditData);
      setName(data?.name)

      if(formJsonData){
          setJson(formJsonData)
      }
    }
  }, [data]);

  const createFormData = async() => {

    if(!(data?.name || name)){
        toast.error("Form name is required.")
        return
    }

    if (data?.ID) {
      // Clean form before sending: do not persist fetched options for API/schema-driven fields
      const cleaned = (form || []).map((r) => ({
        ...(r.enableAddMore !== undefined ? { enableAddMore: r.enableAddMore } : {}),
        columns: r.columns.map((c) => {
          if (!c?.input) return { input: null };
          const inp = { ...c.input };
          const isApiSource = inp.isAPI || inp.sourceType === 'api';
          const isSchemaSource = inp.sourceType === 'schema' || inp.API?.useSchema;
          if (isApiSource || isSchemaSource) {
            // remove runtime-only option arrays
            delete inp.options;
            delete inp.tempOptions;
            delete inp._apiFetched;
            delete inp._schemaFetched;
            delete inp._schemaPreviewFetched;
          }
          return { input: inp };
        })
      }));

      let payload = {
        formID: data?.ID,
        formName : name,
        sub_service_id: data?.sub_service_id,
        service_id : data?.service_id,
        grid: JSON.stringify(cleaned),
      };
      const response = await dispatch(updateForm(payload));

      console.log("response",response)
        if (response.meta?.requestStatus === 'fulfilled') {
            Swal.fire({
                title: 'Form updated',
                text: 'Your form has been updated successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
                timer: 1800,
                timerProgressBar: true,
            });
            setForm([])
            setJson([])
            navigate(-1)
      }else{
        const errMsg = response.error?.message || response.payload?.message || 'Please try again.';
        Swal.fire({
            title: 'Failed to create form',
            text: errMsg,
            icon: 'error',
            confirmButtonText: 'OK',
        });

      }
    } else {
     // Clean form before sending for create as well
     const cleaned = (form || []).map((r) => ({
       ...(r.enableAddMore !== undefined ? { enableAddMore: r.enableAddMore } : {}),
       columns: r.columns.map((c) => {
         if (!c?.input) return { input: null };
         const inp = { ...c.input };
         const isApiSource = inp.isAPI || inp.sourceType === 'api';
         const isSchemaSource = inp.sourceType === 'schema' || inp.API?.useSchema;
         if (isApiSource || isSchemaSource) {
           delete inp.options;
           delete inp.tempOptions;
           delete inp._apiFetched;
           delete inp._schemaFetched;
           delete inp._schemaPreviewFetched;
         }
         return { input: inp };
       })
     }));

     let payload = {
        formName: name,
        sub_service_id: data?.sub_service_id,
        service_id : data?.service_id,
        grid: JSON.stringify(cleaned),
      };
      const response = await dispatch(createForm(payload));

      if (response.meta?.requestStatus === 'fulfilled') {
            Swal.fire({
                title: 'Form created',
                text: 'Your form has been created successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
                timer: 1800,
                timerProgressBar: true,
            });
            setForm([])
            setJson([])
            navigate(-1)
      }else{
        const errMsg = response.error?.message || response.payload?.message || 'Please try again.';
        Swal.fire({
            title: 'Failed to create form',
            text: errMsg,
            icon: 'error',
            confirmButtonText: 'OK',
        });

      }
    }
  };

  const handleNext = () => {
    formBuilderRef.current.set();
    if (activeTab === 1) setActiveTab(2);
  };

  const handleBack = () => {
    if (activeTab === 2) setActiveTab(1);
  };

  return (
    <div className="container-fluid" style={{ display: "flex", flexDirection: "column", minHeight: "80%", backgroundColor: "#fff" }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.75rem 1.5rem",
          borderBottom: "1px solid #dee2e6",
          flexShrink: 0,
        }}
      >
        <h5 className="mb-0">{data?.ID ? "Edit Form" : "Create Form"}</h5>
        <button className="btn btn-sm btn-outline-danger" onClick={() => navigate(-1)}>
          &times; Cancel
        </button>
      </div>

      {/* Body — scrollable */}
      <div style={{ flex: 1, overflowY: "auto", padding: "1rem 1.5rem",minHeight:"70vh" }}>
        <Label>Form Name:</Label>
        <Input
          value={name}
          onChange={(e) => setName(e?.target?.value)}
          placeholder="Enter form name"
          disabled={activeTab > 1}
        />

        {activeTab === 1 ? (
          <FormBuilder
            ref={formBuilderRef}
            setForm={setForm}
            setJson={setJson}
            formData={form || []}
            jsonData={json || []}
          />
        ) : null}

        {activeTab === 2 ? (
          <PreviewForm grid={form} type={type} json={json} />
        ) : null}
      </div>

      {/* Footer */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          gap: "0.5rem",
          padding: "0.75rem 1.5rem",
          borderTop: "1px solid #dee2e6",
          flexShrink: 0,
        }}
      >
        {activeTab === 1 ? (
          <button className="btn bg-primary" onClick={() => handleNext()}>
            Preview Form
          </button>
        ) : (
          <>
            <button className="btn bg-white" onClick={() => handleBack()}>
              Back
            </button>
            <button className="btn bg-primary" onClick={() => createFormData()}>
              {data.ID ? "Save" : "Create"}
            </button>
          </>
        )}
        <button className="btn btn-danger" onClick={() => navigate(-1)}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CreateFormBuilder;
